import React from 'react';
import ReportView from './reportView';

// La vue porte sa propre fiche : cet enrobage n'ajoutait qu'une grille.
function Report() {
  return <ReportView />;
}

export default Report;
